/** Ceníková šablona — množství se počítá z reálných cm v metadata. */
export const WORK_REPORT_DEEPENING_CATALOG_ACTIVITY_NAME = 'Prohloubení výkopu o 10 cm';

/** cm z povrchů (první s hodnotou > 0), jinak legacy `excavationDeepeningCm`. */
export function workReportDeepeningCm(surfaces: unknown, legacy?: unknown): number | undefined {
  if (Array.isArray(surfaces)) {
    for (const s of surfaces) {
      const n = Number(s && typeof s === 'object' ? (s as Record<string, unknown>)['deepeningCm'] : NaN);
      if (n > 0) return n;
    }
  }
  const leg = Number(legacy);
  return leg > 0 ? leg : undefined;
}

export const isDeepeningWorkReportActivityName = (name: string): boolean =>
  /prohlouben/i.test(name ?? '');

export function formatWorkReportDeepeningSpecText(surfaces: unknown, legacy?: unknown): string | undefined {
  const cm = workReportDeepeningCm(surfaces, legacy);
  return cm != null ? `o ${cm} cm` : undefined;
}

export function formatDeepeningWorkReportActivityName(
  name: string,
  surfaces: unknown,
  legacy?: unknown,
): string {
  const cm = workReportDeepeningCm(surfaces, legacy);
  return cm != null && isDeepeningWorkReportActivityName(name)
    ? name.replace(/o\s*\d+\s*cm/i, `o ${cm} cm`)
    : name;
}
